
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem3ExemptGrid extends Serenity.EntityGrid<PsAdvPromoItem3ExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItem3ExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem3ExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItem3ExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem3ExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem3ExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItem3ExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}